export enum Locales {
  en = 'en',
}
